import getConfig from 'next/config';

const DEFAULT_TIMEOUT_IN_MS = 5000;

function getRecaptchaToken(
  action: string,
  timeoutInMs: number = DEFAULT_TIMEOUT_IN_MS,
): Promise<string> {
  const {
    publicRuntimeConfig: { GOOGLE_RECAPTCHA, INTEGRATION_TESTING },
  } = getConfig();

  if (INTEGRATION_TESTING) {
    return Promise.resolve('');
  } else {
    return new Promise((resolve, reject) => {
      try {
        if (!('grecaptcha' in window) || window.grecaptcha === undefined) {
          reject(new Error('Recaptcha not loaded'));
          return;
        }

        const timeout = setTimeout(() => {
          reject(new Error('Recaptcha token request timed out'));
        }, timeoutInMs);
        (window as any).grecaptcha?.enterprise.ready(() => {
          return (window as any).grecaptcha.enterprise
            .execute(GOOGLE_RECAPTCHA, {
              action,
            })
            .then((token: string) => {
              clearTimeout(timeout);
              resolve(token);
            })
            .catch((error: unknown) => {
              clearTimeout(timeout);
              reject(error);
            });
        });
      } catch (error) {
        reject(error);
      }
    });
  }
}

export { getRecaptchaToken };
